import localStorage from 'common/local_storage';

const SHOP_PANEL_TOGGLE_STATUS_KEY = 'shop-panel-toggle-status';

export default class ShopPanel {
  constructor(toggleElement, panelElement) {
    this.toggleElement = toggleElement;
    this.panelElement = panelElement;

    if (this.toggleElement && this.panelElement) {
      this.initializeToggleStatus();
      this.togglePanelElement();
      this.attachListeners();
    }
  }

  initializeToggleStatus() {
    this.toggleStatus =
      localStorage.getItem(SHOP_PANEL_TOGGLE_STATUS_KEY) || 'false';
  }

  attachListeners() {
    this.toggleElement.addEventListener('click', e => {
      e && e.preventDefault();
      this.toggleValue();
      this.togglePanelElement();
    });
  }

  togglePanelElement() {
    if (this.toggleStatus === 'true') {
      this.panelElement.classList.remove('hide');
    } else {
      this.panelElement.classList.add('hide');
    }
  }

  toggleValue() {
    if (this.toggleStatus === 'true') {
      this.toggleStatus = 'false';
    } else {
      this.toggleStatus = 'true';
    }

    localStorage.setItem(SHOP_PANEL_TOGGLE_STATUS_KEY, this.toggleStatus);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/application/shop-panel.js